import React from "react";
import {
  Modal,
  Text,
  TouchableOpacity,
  View,
  StyleSheet,
  Platform,
} from "react-native";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-native-paper";
import { Picker } from "react-native";
import { useToast } from "react-native-toast-notifications";
import { updateChinaOrderPriority } from "../../../redux/dispatcher/chinaTrackerDispatcher";
import { useTranslation } from "../../../utils/useTranslation";
import {
  getOrders,
  manualUpdateCustomerOrderStatus,
} from "../../../redux/dispatcher/portalDispatcher";
import Spinner from "../../../components/shared/Spinner";

interface TrackerEnquiryModalProps {
  visible: boolean;
  onClose: () => void;
  order: any;
}

interface FormData {
  orderStatus: string;
}

const CustomerOrderShipmentStatusUpdate: React.FC<TrackerEnquiryModalProps> = ({
  visible,
  onClose,
  order,
}) => {
  const dispatch = useDispatch<any>();
  const { t } = useTranslation();
  const { loadingAction } = useSelector((state: any) => state.portal);

  const toast = useToast();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    defaultValues: {
      orderStatus: order?.orderStatus || "",
    },
  });

  const onSubmit = async (data: FormData) => {
    const payload: any = {
      orderStatus: data.orderStatus,
    };
    try {
      // Replace with your actual dispatch call
      await dispatch(
        manualUpdateCustomerOrderStatus({ _id: order._id, payload: payload }),
      )
        .unwrap()
        .then(() => {
          toast.show("Order Status Updated successfully", {
            type: "success",
          });
          onClose(); // Close modal after success
          dispatch(getOrders() as any).unwrap();
        })
        .catch((err: any) => {
          toast.show(err, {
            type: "danger",
          });
        });
    } catch (err) {
      console.error("Order status update failed:", err);
    }
  };

  return (
    <Modal visible={visible} transparent animationType="slide">
      <View style={styles.overlay}>
        <View style={styles.modalContainer}>
          <View style={styles.header}>
            <Text style={styles.title}>
              {"Update Order Status"}: {order?.OrderNumber1}
            </Text>
            <TouchableOpacity onPress={onClose} style={styles.closeButton}>
              <Text style={styles.closeButtonText}>✕</Text>
            </TouchableOpacity>
          </View>

          <Text style={styles.inputLabel}>Update Order Status</Text>
          {loadingAction ? (
            <View style={styles.spinnerContainer}>
              <Spinner size="small" color="#74BBFF" />
            </View>
          ) : (
            <>
              <Controller
                control={control}
                name="orderStatus"
                rules={{ required: "Order Status is required" }}
                render={({ field: { onChange, value } }) => (
                  <View
                    style={[
                      styles.pickerWrapper,
                      Platform.OS === "android" && {
                        borderWidth: 1.5,
                        borderColor: "#a6a6a6",
                        borderRadius: 10,
                      },
                    ]}
                  >
                    <Picker
                      selectedValue={value}
                      onValueChange={onChange}
                      style={styles.picker}
                    >
                      <Picker.Item label="-- Select Order Status --" value="" />
                      <Picker.Item label={"Ready"} value="Ready" />
                      <Picker.Item label={"Shipped"} value="Shipped" />
                    </Picker>
                  </View>
                )}
              />
              {errors.orderStatus && (
                <Text style={styles.errorStyle}>
                  {errors.orderStatus.message}
                </Text>
              )}

              <Button
                mode="contained"
                onPress={handleSubmit(onSubmit)}
                style={styles.submitButton}
              >
                Submit
              </Button>
            </>
          )}
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.2)",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContainer: {
    backgroundColor: "#fff",
    padding: 25,
    width: 500,
    borderRadius: 10,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 10,
  },
  title: {
    fontSize: 16,
    fontWeight: "bold",
    flexShrink: 1,
  },
  closeButton: {
    backgroundColor: "#1E88E5",
    borderRadius: 16,
    paddingHorizontal: 10,
    paddingVertical: 4,
  },
  closeButtonText: {
    color: "#fff",
    fontSize: 16,
  },
  inputLabel: {
    fontWeight: "bold",
    marginBottom: 5,
    marginTop: 20,
    fontSize: 14,
  },
  pickerWrapper: {
    marginBottom: 10,
  },
  picker: {
    height: 50,
    width: "100%",
  },
  errorStyle: {
    color: "red",
    fontSize: 13,
    marginBottom: 10,
  },
  submitButton: {
    marginTop: 15,
    backgroundColor: "#000",
  },
  spinnerContainer: {
    justifyContent: "center",
    alignItems: "center",
    marginTop: 20,
  },
});

export default CustomerOrderShipmentStatusUpdate;
